// Light Theme design tokens (No dark theme, no background gradients)
export const C = {
  primary:       '#2563EB',   // Royal blue
  primaryHover:  '#1D4ED8',
  primaryLight:  '#EFF6FF',
  secondary:     '#0EA5E9',   // Sky blue
  success:       '#10B981',   // Emerald green
  successLight:  '#ECFDF5',
  warning:       '#F59E0B',   // Amber
  warningLight:  '#FFFBEB',
  border:        '#E2E8F0',
  borderLight:   '#F1F5F9',
  bgPage:        '#FFFFFF',
  bgSection:     '#F8FAFC',
  bgCard:        '#FFFFFF',
  textPrimary:   '#0F172A',   // Slate 900
  textSecondary: '#475569',   // Slate 600
  textMuted:     '#64748B',   // Slate 500
};

export const Section = ({ children, sx = {}, id }) => {
  const { Box } = require('@mui/material');
  return (
    <Box id={id} component="section" sx={{ py: { xs: 7, md: 11 }, ...sx }}>
      {children}
    </Box>
  );
};

export const SectionLabel = ({ children }) => {
  const { Typography } = require('@mui/material');
  return (
    <Typography sx={{
      display: 'inline-block',
      fontSize: '0.72rem',
      fontWeight: 800,
      letterSpacing: '0.15em',
      textTransform: 'uppercase',
      color: C.primary,
      mb: 1.5,
    }}>
      {children}
    </Typography>
  );
};
